export default "__VITE_ASSET__BuXMygVR__"